import {
    Create,
    TextInput,
    required,
    SimpleForm,
    SelectInput,
    minValue,
    NumberInput,
} from 'react-admin';
import { ORGANIZATION_RESOURCE_TYPES } from '../../common/constants';
import { OrganizationAutocomplete } from '../../common/inputs/autoCompleteInputs/OrganizationAutoComplete';
import { KeyValueInput } from '../../common/inputs/KeyValueInput';

const OrganizationResourcesCreate = () => (
    <Create redirect={'/organization-resources'}>
        <SimpleForm>
            <TextInput source="title" fullWidth validate={[required()]} />
            <NumberInput source="displayOrder" fullWidth validate={[minValue(1)]} />
            <OrganizationAutocomplete alwaysOn validate={[required()]} />
            <SelectInput
                source="type"
                label={'Resource Type'}
                fullWidth
                validate={[required()]}
                choices={ORGANIZATION_RESOURCE_TYPES}
            />
            <KeyValueInput source="data" label="Add Config" fullWidth />
        </SimpleForm>
    </Create>
);

export default OrganizationResourcesCreate;
